import CircularProgress from '@mui/material/CircularProgress';

export default function BackDropLoading({loading}) {
  return (
    <>
        {
            loading &&
            <div className='app-loading'>
                <CircularProgress size={90}/>
            </div>
        }
    </>
  );
}